import { Component, createRef } from 'react'
import { Text, View, findNodeHandle } from 'react-native'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { WebVTT } from 'vtt.js'
import { media } from '../../../../../style/media'

const baseYOffset = (playerHeight) => playerHeight * 0.05

const Region = styled(View)`
  flex-direction: row;
  justify-content: center;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  transition-duration: 0.2s;
  transition-property: transform;
  transition-timing-function: ease-in-out;
`

const Track = styled(Text)`
  padding: 0 20px;
  margin-bottom: 6px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.5);
  color: ${(props) => props.theme.colors.text};
  font-size: ${(props) => props.theme.fontSizes.medium}px;
  ${media.md`
    font-size: ${(props) => (props.isTv ? '55px' : '2vw')};
  `};
`

const yOffsetStyle = (playerHeight, yOffset) => {
  const offset = baseYOffset(playerHeight) + (yOffset ? yOffset(playerHeight) : 0)
  return { transform: [{ translateY: -offset }] }
}

class SubtitlesRegion extends Component {
  region = createRef()
  text = createRef()

  shouldComponentUpdate(nextProps) {
    if (this.props.enabled && !nextProps.enabled) {
      this.updateCue()
    }
    if (this.props.yOffset !== nextProps.yOffset) {
      this.changeYOffset(nextProps.yOffset)
    }
    return false
  }

  changeYOffset = (yOffset) => {
    this.region.current.setNativeProps({
      style: yOffsetStyle(this.props.playerHeight, yOffset),
    })
  }

  /** @public */
  updateCue = (cue) => {
    const textDiv = findNodeHandle(this.text.current)
    let fc
    while ((fc = textDiv.firstChild)) {
      textDiv.removeChild(fc)
    }
    if (cue?.text) {
      textDiv.appendChild(WebVTT.convertCueToDOMTree(window, cue.text))
    }
  }

  render() {
    const { yOffset, playerHeight } = this.props
    return (
      <Region ref={this.region} style={yOffsetStyle(playerHeight, yOffset)}>
        <Track ref={this.text} />
      </Region>
    )
  }
}

SubtitlesRegion.propTypes = {
  enabled: PropTypes.bool,
  playerHeight: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired]),
  yOffset: PropTypes.func,
}

export default SubtitlesRegion
